import { validateDigitOnly } from '@/utils/validation'

export interface Address {
  address: string
  block: string
  fullName: string
  landmark: string
  mobileNumber: string | number
  pinCode: string | number
  village: string
  full_display_address?: string
  block_id?: string
  district_id?: string
  state_id?: string
}

export interface Location {
  block?: string
  block_id?: number | string
  district?: string
  district_id?: number | string
  kheti_block_id?: number | string
  kheti_district_id?: number | string
  kheti_state_id?: number | string
  pincode?: number | string
  state?: string
  state_id?: number | string
  village?: string
  village_id?: number
}

export type Option = { id: string; name: string }

export const validator = {
  fullName: {
    required: true,
  },
  mobileNumber: {
    required: true,
    onChange: (value: string) => validateDigitOnly(value) && value.length <= 10,
    onBlur: (value: string) => value.length === 10,
  },
  pinCode: {
    required: true,
    onChange: (value: string) => validateDigitOnly(value) && value.length <= 6,
    onBlur: (value: string) => value.length === 6,
  },
  address: {
    required: true,
    onChange: (value: string) => value.length <= 50,
  },
  landmark: {
    onChange: (value: string) => value.length <= 20,
  },
}
